import { Col, Container } from "react-bootstrap";
import { Contact } from "../../components/Contact";
import { Education } from "../../components/Education";
import { Experience } from "../../components/Experience";
import Footer from "../../components/Footer";
import { Header } from "../../components/Header";
import { Perfil } from "../../components/Perfil";
import { Projects } from "../../components/Projects";
import { Wrapper } from "../../components/Wrapper";
import { MainContainer } from "../../components/MainContainer";
import { Technologies } from "../../components/Technologies";

export const Home = () => {
  return (
    <Wrapper>
      <Header />
      <Container>
        <MainContainer>
          <Col lg={3}>
            <Perfil />
          </Col>
          <Col lg={9}>
            <main>
              <Technologies />
              <Experience />
              <Projects />
              <Education />
              <Contact />
            </main>
          </Col>
        </MainContainer>
      </Container>
      <Footer />
    </Wrapper>
  );
};
